import {DateTimeIsoString, SelectOptions} from '@aviary/store/common/common.types';
import {Patron} from '@store/patron/patron.types';

export const REGISTRATION_FEATURE_KEY = 'registration';
export const VERIFICATION_EMAIL_RESEND_COOLDOWN_MS: number = 15000; // 15 seconds

export interface EmailVerificationRequest {
  readonly email: string;
}

export interface EmailVerificationValue {
  readonly verificationCode: string;
}

export type EmailVerificationStatus = 'PENDING' | 'APPROVED' | 'ACCEPTED' | 'EXPIRED' | 'CANCELED';

export interface EmailVerificationStatusView {
  readonly status: EmailVerificationStatus;
  readonly isExistingPatron: boolean;
  readonly email: string;
  readonly expiresAt: DateTimeIsoString;
}

export interface CreatePasswordValue {
  readonly password: string;
  readonly branchId: number;
  readonly acceptTerms: boolean;
}

export const REGISTRATION_DETAILS_PROPERTIES = [
  'firstName', 'lastName', 'suffix', 'address', 'address2', 'city', 'state',
  'dateOfBirth', 'branchId'
] as const;

export type DetailsValue = Pick<Patron, typeof REGISTRATION_DETAILS_PROPERTIES[number]> & {
  readonly zip: string;
};

export interface NotificationPreferencesValue {
  notificationEmail: string;
  mobilePhone: string;
  notifyMethod: 'EMAIL' | 'TEXT';
  smsTermsAccepted: boolean;
}

export const NOTIFICATION_OPTIONS: SelectOptions<string> = [
  {displayName: 'Email', value: 'EMAIL'},
  {displayName: 'Text', value: 'TEXT'}
];

export const PATRON_REGISTRATION_PROPERTIES = [
  'firstName', 'lastName', 'suffix', 'address', 'address2', 'city', 'state',
  'dateOfBirth', 'notificationEmail',

  'phone1Mobile', 'phone1Ext', 'phone2', 'phone2Mobile', 'phone2Ext',
  'phoneSms', 'phoneCall', 'branchId'
] as const;

export type OPACRegistrationValue = Pick<Patron, typeof PATRON_REGISTRATION_PROPERTIES[number]> & {
  readonly zip: string;
  readonly notifyEmail: boolean;
  readonly notifyText: boolean;
  readonly smsTermsAccepted: boolean;
  readonly mobilePhone: string;
  readonly password: string;
  readonly verificationUUID: string;
};

export const REGISTRATION_CREATE_ACCOUNT_STEPS = ['enterEmail', 'verifyEmail', 'enterDetails', 'setNotifications', 'createPassword', 'complete'] as const;
export const REGISTRATION_LOOKUP_ACCOUNT_STEPS = ['lookupAccount', 'verifyEmail', 'createPassword', 'complete'] as const;
export type RegistrationStep =
  typeof REGISTRATION_CREATE_ACCOUNT_STEPS[number]
  | typeof REGISTRATION_LOOKUP_ACCOUNT_STEPS[number];

export const POLL_VERIFICATION_STATUS_TIME_INTERVAL: number = 10000; // 10 seconds
